import api from '../utils/api';

export const getAllUsers = async () => {
    const response = await api.get('/users');
    return response.data;
};

export const createUser = async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
};

export const updateUser = async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
};

export const resetPassword = async (id, newPassword) => {
    const response = await api.patch(`/users/${id}/password`, { newPassword });
    return response.data;
};

export const toggleUserStatus = async (id, status) => {
    const response = await api.patch(`/users/${id}/status`, { status });
    return response.data;
};